import request from '@/utils/request'

let Store_authApi = {

  /*门店认证列表*/
  list(data) {
    return request._post('/shop/plus.store_auth.Index/index', data);
},
/*添加门店认证*/
add(data) {
    return request._post('/shop/plus.store_auth.Index/add', data);
},
/*修改门店认证*/
edit(data) {
    return request._post('/shop/plus.store_auth.Index/edit', data);
},
/*删除门店认证*/
del(data) {
    return request._post('/shop/plus.store_auth.Index/del', data);
},
/*门店认证详情*/
detail(data) {
  return request._post('/shop/plus.store_auth.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.store_auth.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.store_auth.Setting/getSetting', data, errorback);
    }, // 审核
    passCanel(data) {
     return request._post('/shop/plus.store_auth.Index/passCanel', data);
   },
}
export default Store_authApi;



// WEBPACK FOOTER //
// ./src/api/store_auth.js